import { Typography } from "@mui/material";
import { ReactElement } from "react";
import { FieldValues, Path, UseControllerProps } from "react-hook-form";

import { FlexBox } from "~frontend/components/FlexBox";

import { RhfCurrencyField } from "./RhfCurrencyField";

export interface RhfCurrencyRangeProps<T extends FieldValues> {
  control: UseControllerProps<T>["control"];
  name: UseControllerProps<T>["name"];
  fullWidth?: boolean;
  bottomLabel?: string;
  lowLabel?: string;
  highLabel?: string;
}

export function RhfCurrencyRange<T extends FieldValues>({
  control,
  name,
  fullWidth = true,
  bottomLabel,
  lowLabel = "Lower Limit",
  highLabel = "Upper Limit",
}: RhfCurrencyRangeProps<T>): ReactElement {
  return (
    <FlexBox
      direction="column"
      gap={1}
      sx={{ width: fullWidth ? "100%" : "auto" }}
    >
      <FlexBox gap={2}>
        <RhfCurrencyField
          control={control}
          name={`${name}[0]` as Path<T>}
          label={lowLabel}
          fullWidth
        />
        <RhfCurrencyField
          control={control}
          name={`${name}[1]` as Path<T>}
          label={highLabel}
          fullWidth
        />
      </FlexBox>
      {bottomLabel && (
        <Typography variant="caption" color="textSecondary">
          {bottomLabel}
        </Typography>
      )}
    </FlexBox>
  );
}
